<div
  class="max-w-7xl mx-auto pt-0 p-4 md:py-8 flex flex-col md:flex-row gap-8 min-h-screen"
>
  <aside class="w-full md:w-90 shrink-0">
    <div
      class="md:rounded-xl md:shadow-md md:border md:border-gray-100 md:overflow-hidden flex flex-col rounded-lg"
    >
      <div
        class="bg-[#2187AB] p-6 flex flex-col items-center text-[#ffffff] text-center relative -mx-4 pt-8 pb-14 md:pb-6"
      >
        <div
          class="w-18 h-18 bg-[#F3F4F6] border-3 border-[#ffffff] rounded-full flex items-center justify-center mb-3 relative group"
        >
          @if (user().profilePhotoUrl) {
            <img
              [src]="user().profilePhotoUrl"
              [alt]="user().name"
              class="w-full h-full rounded-full object-cover"
            />
          } @else {
            <span
              class="text-3xl font-bold text-[#ffffff] tracking-wider [-webkit-text-stroke:1px_#114455]"
            >
              {{ user().initials }}</span
            >
          }
          <span
            class="absolute bottom-0.5 p-0.5 -right-0.5 bg-[#F77B61] rounded-sm text-2xs cursor-pointer"
          >
            <sham-i-edit-01 class="*:size-4" />
          </span>
        </div>
        <h3 class="font-semibold text-[#ffffff] text-lg">{{ user().name }}</h3>
        <p class="text-sm font-light text-[#E7E7FF]">{{ user().email }}</p>
      </div>

      <nav
        class="p-4 space-y-1 -mt-8 relative z-10 bg-[#ffffff] shadow-lg border border-[#F3F4F6] md:mt-0 md:shadow-none md:border-none rounded-lg md:rounded-none"
      >
        @for (item of menuItems(); track item.route) {
          <a
            [routerLink]="item.route"
            routerLinkActive="bg-[#DEEFF5] font-medium"
            class="w-full flex items-center gap-3 p-4 rounded-lg hover:bg-gray-50 transition cursor-pointer m-0"
          >
            @switch (item.icon) {
              @case ('user') {
                <sham-i-user-03 class="*:size-5" />
              }
              @case ('lock') {
                <sham-i-lock-password-Stroke class="*:size-5" />
              }
              @case ('location') {
                <sham-i-location-address class="*:size-5" />
              }
              @case ('cart') {
                <sham-i-shopping-cart-check class="*:size-5" />
              }
              @case ('money') {
                <sham-i-money-01 class="*:size-5" />
              }
              @case ('package') {
                <sham-i-package class="*:size-5" />
              }
              @case ('ticket') {
                <sham-i-ticket-01-stroke class="*:size-5" />
              }
              @case ('notifications') {
                <sham-i-bell class="*:size-5" />
              }
              @case ('wallet') {
                <sham-i-wallet-02 class="*:size-5 [&_path]:fill-black" />
              }
            }

            <span class="text-base">
              {{ item.label | translate }}
              @if (item.badgeCount) {
                <span class="ml-1 text-[#2187AB]">({{ item.badgeCount }})</span>
              }
            </span>
          </a>
        }
      </nav>
    </div>
  </aside>

  <main class="min-w-0 flex-1">
    <router-outlet></router-outlet>
  </main>
</div>
